import React from 'react';
import { Button, SxProps, Theme } from '@mui/material';
import { theme } from '../../../../../common/styles/theme';

const formatTime = (seconds: number): string => {
	const total = Math.max(0, Math.floor(seconds || 0));
	const m = Math.floor(total / 60);
	const s = total % 60;
	return `${m}:${s.toString().padStart(2, '0')}`;
};

// Lesson moment on an exercise/word card — highlights that line in the transcript beside the tab and plays it.
export const TimestampButton: React.FC<{ time: number, onClick: (time: number) => void, sx?: SxProps<Theme> }> = ({ time, onClick, sx }) => (
	<Button
		variant={'outlined'}
		size={'small'}
		onClick={(e) => { e.stopPropagation(); onClick(time); }}
		sx={{
			flexShrink: 0,
			minWidth: 0,
			height: theme.spacing(2.5),
			px: .5,
			py: 0,
			color: theme.palette.grey[500],
			fontSize: theme.typography.subtitle1,
			fontWeight: 400,
			whiteSpace: 'nowrap',
			...(sx as object),
		}}
	>
		{formatTime(time)}
	</Button>
);
